/*      Dara - Agreement
 * All axios endpoints for agreements. They will be prefixed with /api/myhq-spa/agreement
 */
import axios from '@/plugins/axios'
import { useAppStore } from '@/stores/app'
import { useAuthStore } from '@/stores/auth'
import type { IGetAgreement } from '@/interfaces/api/Dara/Agreement'
import type IDataResponse from '@/interfaces/api-resources/DataResponse'
import type IPaginatedAdditionalResponse from '@/interfaces/api-resources/PaginatedAdditionalResponse'

export default {
  baseUrl() {
    const appStore = useAppStore()

    return `${appStore.daraApiBaseUrl}/agreements/`
  },

  getAgreement() {
    const authStore = useAuthStore()

    return axios.get<IGetAgreement, IGetAgreement>(this.baseUrl() + authStore.organisation?.customer_agreement_id)
  },

  getAgreementLicenceTypes(id: number) {

    return axios.get<IDataResponse<Domain.Licences.Resources.ApiV3.LicenceTypeCountExtraResource[]>, IDataResponse<Domain.Licences.Resources.ApiV3.LicenceTypeCountExtraResource[]>>(
      `${this.baseUrl()}${id}/licence-types`,
    ).then(data => data.data)
  },

  getLicenceOrders(id: number, searchParams: string) {
    return axios.get<
      IPaginatedAdditionalResponse<App.Http.Resources.ApiV3.LicenceOrderResource[],{
        currency_display_sign: string
        future_licence_orders: { data: [] }
        is_po_required: boolean }>,
      IPaginatedAdditionalResponse<App.Http.Resources.ApiV3.LicenceOrderResource[],{
        currency_display_sign: string
        future_licence_orders: App.Http.Resources.ApiV3.LicenceOrderResource[]
        is_po_required: boolean }>
    >(this.baseUrl() + id + '/licence-orders' + '?' + searchParams)
  },

  storeLicenceOrder(id: number, data: object) {
    return axios.post(this.baseUrl() + id + '/licence-orders', data)
  },
}
